import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import { Accessor, FilterBasedAccessor, PaginationAccessor } from "./";

var each = require("lodash/each");

export var ResetSearchAccessor =
/*#__PURE__*/
function (_Accessor) {
  _inherits(ResetSearchAccessor, _Accessor);

  function ResetSearchAccessor() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      query: true,
      filter: true,
      pagination: true
    };

    _classCallCheck(this, ResetSearchAccessor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResetSearchAccessor).call(this));
    _this.options = options;
    return _this;
  }

  _createClass(ResetSearchAccessor, [{
    key: "canReset",
    value: function canReset() {
      var query = this.searchkit.query;
      var options = this.options;
      return options.pagination && query.getFrom() > 0 || options.query && query.getQueryString().length > 0 || options.filter && query.getSelectedFilters().length > 0;
    }
  }, {
    key: "performReset",
    value: function performReset() {
      var query = this.searchkit.query;

      if (this.options.query) {
        this.searchkit.getQueryAccessor().resetState();
      }

      if (this.options.filter) {
        var filters = this.searchkit.getAccessorsByType(FilterBasedAccessor);
        each(filters, function (accessor) {
          return accessor.resetState();
        });
        each(query.getSelectedFilters() || [], function (f) {
          return f.remove();
        });
      }

      var paginationAccessor = this.searchkit.getAccessorByType(PaginationAccessor);

      if (this.options.pagination && paginationAccessor) {
        paginationAccessor.resetState();
      }
    }
  }]);

  return ResetSearchAccessor;
}(Accessor);